export interface ResetPassword {
  username: string;
  email: string;
  token: string;
  password: string;
  passwordRepeat: string;
}
